import type { SVGProps } from "react";

const SvgFioLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 631 447"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      d="m432.559 283.328 85.07-27.914-85.07-27.629v-79.836l-114.985 39.883-111.16-38.168v76.57l-82.535 28.317 82.812 28.57.004.394v77.641l112.504-39.109.153-.051 113.207 39.168z"
      style={{
        fill: "#00408a",
      }}
      transform="translate(-101.658 -146.394)scale(1.30017)"
    />
    <path
      d="M250.074 220.64c3.36-.578 5.594-.578 7.278 0 .839.286 2.234 1.739 2.234 3.188 0 .871.562 3.187.562 5.215v64.605c0 1.742 1.118 10.719-9.515 17.094v4.059l33.586-11.012v-4.926c-5.317 0-8.395-2.316-8.395-5.496v-36.219c3.637-.871 5.871-1.453 7.832-1.453 1.68 0 3.637.871 4.758 1.738.84.582 1.961 2.028 2.242 3.192.274.867 1.117 3.179 1.399 4.922l1.117 5.507h2.516v-38.531h-3.352c-.281 2.891-.563 5.504-.563 6.082-.281 2.031-1.398 4.344-1.961 5.793-.839 1.738-2.796 3.766-4.476 4.633-3.356 1.742-6.434 2.32-9.793 3.477v-32.446c0-3.476 0-5.793 3.359-7.824l1.114-.578c5.601-3.477 11.757-1.449 14.836.289 3.359 1.453 6.437 8.691 7.558 14.488l.559 2.317h2.797v-31l-55.692 19.406zm76.684 10.141c3.918 0 6.996-3.477 6.996-7.531 0-4.059-3.078-7.535-6.996-7.535-4.199 0-7.274 3.476-7.274 7.535 0 4.054 3.075 7.531 7.274 7.531m-13.528 16.148c-.386-1.558-.132-.375 0 0m13.247 42.368c2.238-.286 5.597-2.602 7-4.051 2.234-2.606 4.753-7.531 6.156-13.328-2.801-.864.836.293-2.242-.578-.559 2.316-1.957 4.929-2.516 6.086-.559.871-1.961 2.898-2.801 3.187l-1.121.289c-.836-.289-.836-4.926-.558-6.375v-36.793c-7.836 3.477-9.235 3.766-17.352 7.531.309 1.793.281 1.93.187 1.664.09.356.208.844.372 1.528l1.402-.289c1.117-.297 2.797-.578 3.074-.578 1.684-.297 1.684 2.023 1.684 4.918v26.656c0 3.187-.563 8.691 1.957 9.562 0 0 2.238 1.16 4.758.571m42.824-15.348c.836-.293 1.394-.293 1.953-.578 9.797-4.055 16.793-15.356 17.074-26.653v-1.738c0-2.902-.555-5.508-1.68-8.113-2.796-7.246-10.355-9.852-17.347-8.402l-2.524.867c-8.394 3.476-14.273 12.457-15.672 21.73-1.117 6.953-.558 16.805 5.875 21.438 3.645 2.609 8.118 2.609 12.321 1.449m-.563-43.168h.563c8.113-1.16 9.793 14.484 9.793 19.699 0 7.824-.844 18.543-9.235 21.149 0 0-.285 0-.558.289-9.52 2.031-9.52-17.383-9.52-23.176 0-7.246 1.676-15.934 8.957-17.961m-235.371 23.773 96.555 33.313-.281-66.344zm190.031-65.48 84.52 28.977v72.718l-84.797 29.258 106.352 36.797V152.285z"
      style={{
        fill: "#fff",
      }}
      transform="translate(-101.658 -146.388)scale(1.30017)"
    />
    <path
      d="M206.922 89.402h27.625v7.633h-17.379v6.808h11.379v7.473h-11.379v14.375h-10.246zm30.312 0h8.891v7.347h-8.891zm0 10.726h8.891v25.563h-8.891z"
      style={{
        fill: "#00408a",
      }}
      transform="translate(-101.658 235.881)scale(1.30017)"
    />
    <path
      d="M250.555 96.734c.668-1.653 1.593-3.078 2.785-4.285a12.55 12.55 0 0 1 4.23-2.809q2.45-.996 5.403-.996c1.933 0 3.722.332 5.375.996q2.471 1 4.257 2.785 1.781 1.787 2.782 4.258c.664 1.652 1 3.465 1 5.426 0 1.969-.336 3.773-1 5.406-.668 1.637-1.594 3.047-2.782 4.238-1.191 1.188-2.609 2.118-4.257 2.782-1.653.668-3.442 1-5.375 1q-2.953.001-5.403-1c-1.632-.664-3.043-1.594-4.23-2.782-1.192-1.191-2.117-2.601-2.785-4.238-.664-1.633-1-3.437-1-5.406 0-1.934.336-3.723 1-5.375m9.316 10.894c.637 1.239 1.672 1.852 3.102 1.852s2.461-.613 3.097-1.852q.951-1.858.953-5.656-.002-3.802-.953-5.637-.954-1.828-3.097-1.828-2.146 0-3.102 1.828-.951 1.835-.953 5.637.002 3.798.953 5.656"
      style={{
        fill: "#00408a",
      }}
      transform="translate(-101.658 250.071)scale(1.30017)"
    />
    <path
      d="M296.773 123.097q.078-.92.079-1.687V88.867h8.859v13.613q1.569-1.668 3.168-2.457c1.062-.519 2.262-.785 3.598-.785q4.67.002 7.335 3.332 2.673 3.335 2.672 9.57c0 4.285-.972 7.606-2.91 9.973q-2.907 3.544-7.906 3.543-5.004.001-7.957-3.945l-1.481 3.41h-5.632q.105-1.091.175-2.024m12.086-2.39q2.433 0 3.313-1.973.884-1.974.883-6.398c0-2.664-.254-4.618-.762-5.852-.508-1.238-1.481-1.855-2.91-1.855q-.956 0-1.813.453c-.574.3-1.191.769-1.859 1.402v9.988q-.002 4.236 3.148 4.235"
      style={{
        fill: "#00408a",
      }}
      transform="translate(-101.658 236.622)scale(1.30017)"
    />
    <path
      d="M348.578 113.41c.063.43.16.863.285 1.309h-8.797q-.349-.857-.347-2.188-3.528 2.754-7.91 2.754c-2.129 0-3.844-.66-5.145-1.992q-1.952-2.002-1.953-5.281 0-4.477 3.789-6.895 3.784-2.43 11.219-2.476V96.41q0-1.044-.789-1.66-.79-.616-2.172-.617c-.895 0-1.641.262-2.246.785q-.909.784-1.196 2.262l-7.472-1.617c.73-2.29 2-3.981 3.808-5.083 1.809-1.093 4.254-1.644 7.336-1.644q5.866-.001 8.68 1.855 2.812 1.857 2.812 5.758v15.606c0 .476.036.929.098 1.355m-8.859-10.355c-4.164.258-6.242 1.554-6.242 3.906q.001 2.81 2.714 2.809.954 0 1.789-.309.831-.31 1.739-.977z"
      style={{
        fill: "#00408a",
      }}
      transform="translate(-101.658 250.146)scale(1.30017)"
    />
    <path
      d="M352.945 89.718h8.793v3.715q2.43-2.003 4.504-3.015a9.8 9.8 0 0 1 4.356-1.016q3.621 0 5.121 2.07t1.5 6.399v17.414h-8.86v-15.196q.001-2.33-.425-3.449c-.289-.75-.969-1.121-2.051-1.121q-.903-.002-1.906.547-.997.55-2.239 1.594v17.625h-8.793z"
      style={{
        fill: "#00408a",
      }}
      transform="translate(-101.658 249.41)scale(1.30017)"
    />
    <path
      d="M381.695 89.402h8.703v20.094l8.758-9.379h8.856l-7.903 8.235 7.809 17.328h-9.856l-4.519-10.567-3.145 3.235v7.332h-8.703z"
      style={{
        fill: "#00408a",
      }}
      transform="translate(-101.658 235.895)scale(1.30017)"
    />
    <path
      d="M432.836 113.41c.062.43.16.863.285 1.309h-8.797q-.346-.857-.347-2.188-3.529 2.754-7.907 2.754c-2.129 0-3.843-.66-5.148-1.992q-1.952-2.002-1.953-5.281.001-4.477 3.789-6.895 3.786-2.43 11.219-2.476V96.41q0-1.044-.786-1.66-.791-.616-2.175-.617-1.338 0-2.243.785-.913.784-1.195 2.262l-7.473-1.617c.731-2.29 1.997-3.981 3.805-5.083 1.809-1.093 4.254-1.644 7.34-1.644q5.866-.001 8.68 1.855 2.812 1.857 2.812 5.758v15.606q0 .715.094 1.355m-8.859-10.355c-4.161.258-6.243 1.554-6.243 3.906q0 2.81 2.719 2.809a5.1 5.1 0 0 0 1.785-.309q.834-.31 1.739-.977z"
      style={{
        fill: "#00408a",
      }}
      transform="translate(-101.658 250.146)scale(1.30017)"
    />
  </svg>
);
export default SvgFioLogo;
